/**
 * Input shape: object keyed by category id, each value has customFields
 * with field id -> { text?: unknown } (text can be string or array of { name: string } for multi-select).
 */
export type CustomInputDataByCategory = Record<
  string,
  { customFields?: Record<string, { savedValue?: { value: string[] }; text?: { name: string }[] }> }
>;

export type CustomFieldDataItem = {
  id: string;
  val: string;
  object_type: string;
};

/**
 * Builds the custom fields payload array from category-keyed custom input data.
 * Used when saving OKRs/Key Results with custom field values.
 *
 * @param isVal - Object keyed by category, each value has customFields with text (or array of { name } for multi-select)
 * @param objectType - '5' for goal/objective, '6' for key result (default)
 */
export function buildCustomFieldsDataArray(
  isVal: CustomInputDataByCategory | null | undefined,
  objectType: '5' | '6' = '6',
  isInitialData = false // true if the data is being built for the initial data
): CustomFieldDataItem[] {
  const keyArrCategory: string[] = [];
  const valArray: unknown[] = [];

  if (isVal) {
    Object.keys(isVal).forEach((v) => {
      const entry = isVal[v];
      if (entry?.customFields) {
        Object.keys(entry.customFields).forEach((objv) => {
          keyArrCategory.push(objv);
          const value = isInitialData ?
            entry.customFields?.[objv]?.savedValue?.value :
            entry.customFields?.[objv]?.text;
          valArray.push(value !== undefined && value !== null ? value : '');
        });
      }
    });
  }

  const finalDataArray: CustomFieldDataItem[] = [];
  for (let i = 0; i < valArray.length; i += 1) {
    const val = valArray[i];
    if (Array.isArray(val)) {
      (val).forEach((item) => {
        finalDataArray.push({
          id: keyArrCategory[i],
          val: typeof item === 'string' ? item : item?.name ?? '',
          object_type: objectType,
        });
      });
    } else {
      finalDataArray.push({
        id: keyArrCategory[i],
        val: val as string,
        object_type: objectType,
      });
    }
  }
  return finalDataArray;
}
